import React from "react";
import Dropdown from "../../static/Dropdown/Dropdown";
import { dropdownItem } from "../../static/Dropdown/types";
import { mapRoundLabelForMob } from "../../helpers";

interface PagerProps {
  setPagingIndexChange: Function;
  selectedPager: number;
  setPageIndex: Function;
  pageIndex: number;
  setTransitionType: Function;
  isDisabled: Boolean;
  setIsDisabled: Function;
  totalItems: number;
  itemsPerPage: number;
  paginateSingleItem: Boolean;
  hasLetterLabels?: Boolean;
  pagerPerItem?: Boolean;
  pagerLabels?: string[];
  setPagerClicked: Function;
  setIsUnchanged: Function;
  isDropdownOnMobile?: Boolean;
  hasNoOrphan?: Boolean;
}

const Pager = (props: PagerProps) => {
  const {
    setPagingIndexChange,
    selectedPager,
    pageIndex,
    setPageIndex,
    setTransitionType,
    isDisabled,
    setIsDisabled,
    totalItems,
    itemsPerPage,
    paginateSingleItem,
    pagerLabels,
    pagerPerItem,
    hasLetterLabels = false,
    setPagerClicked,
    setIsUnchanged,
    isDropdownOnMobile = false,
    hasNoOrphan = true // change back to false
  } = props;

  let numberOfPagers;
  let pageAsNormal = true;
  if (paginateSingleItem || pagerPerItem) {
    numberOfPagers = totalItems;
  } else {
    numberOfPagers = Math.ceil(totalItems / itemsPerPage);
  }

  const alphabet = "abcdefghijklmnopqrstuvwxyz";
  const pagers: { index: number; active: Boolean }[] = [];

  if (hasNoOrphan && pageIndex * itemsPerPage > numberOfPagers - itemsPerPage) {
    pageAsNormal = false;
  }

  for (var i = 0; i < numberOfPagers; i++) {
    if (pagerPerItem) {
      let active;

      if (pageAsNormal) {
        active =
          i <= selectedPager * itemsPerPage + itemsPerPage - 1 &&
          i >= selectedPager * itemsPerPage;
      } else {
        active = i >= numberOfPagers - itemsPerPage;
      }

      pagers.push({
        index: i,
        active
      });
    } else {
      let active = paginateSingleItem
        ? i <= selectedPager + itemsPerPage - 1 && i >= selectedPager
        : i === selectedPager;

      pagers.push({
        index: i,
        active
      });
    }
  }
  const onPagerClick = (index: number, active: Boolean) => {
    if (!isDisabled && !active) {
      changePager(index);
    }
  };

  const changePager = (index: number) => {
    setIsDisabled(true);
    setPagerClicked(true);
    setIsUnchanged(false);
    if (!pagerPerItem ? pageIndex < index : pageIndex < index / itemsPerPage) {
      setTransitionType("slide-left");
    } else if (
      !pagerPerItem ? pageIndex > index : pageIndex > index / itemsPerPage
    ) {
      setTransitionType("slide-right");
    } else {
      return;
    }

    setPagingIndexChange(Math.abs(index - pageIndex));

    if (paginateSingleItem && index + itemsPerPage >= totalItems) {
      setPageIndex(totalItems - itemsPerPage);
    } else {
      if (pagerPerItem) {
        setPageIndex(Math.floor(index / itemsPerPage));
      } else {
        setPageIndex(index);
      }
    }

    // unbind the click for the time it takes to animate
    setTimeout(() => {
      setIsDisabled(false);
    }, 1001);
  };

  const selectedDropdown = {
    value: selectedPager,
    label: pagerLabels ? pagerLabels[selectedPager] : selectedPager
  } as dropdownItem;

  return (
    <>
      <div
        className={`carousel-pager carousel-pager--single-item ${
          isDropdownOnMobile ? "carousel-pager--tablet-and-above" : ""
        }`}
      >
        {pagers.map(value => (
          <div
            key={value.index}
            className="carousel-pager__item-wrapper"
            onClick={() => onPagerClick(value.index, value.active)}
          >
            {hasLetterLabels ? (
              <span className="carousel-pager__label">
                {alphabet.charAt(value.index).toUpperCase()}
              </span>
            ) : null}
            {pagerLabels && pagerLabels.length && pagerLabels[value.index] ? (
              <>
                <span className="carousel-pager__label">
                  {pagerLabels[value.index]}
                </span>
                <span className="carousel-pager__label carousel-pager__label--mobile">
                  {mapRoundLabelForMob(pagerLabels[value.index])}
                </span>
              </>
            ) : null}
            <div
              className={
                "carousel-pager__item " + (value.active ? "active" : "")
              }
            />
          </div>
        ))}
      </div>
      {isDropdownOnMobile ? (
        <div className="carousel-pager carousel-pager--dropdown">
          <Dropdown
            options={pagers.map(pager => {
              return {
                value: pager.index,
                label: pagerLabels ? pagerLabels[pager.index] : pager.index
              } as dropdownItem;
            })}
            value={selectedDropdown}
            onChange={value => {
              changePager(value.value as number);
            }}
          />
        </div>
      ) : null}
    </>
  );
};

export default Pager;
